import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function WithdrawIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M12 2.49 5.327 9.163l1.044 1.07 4.88-4.88V12.5h1.5V5.344l4.878 4.863 1.044-1.044zm-.75 12.01v3h1.5v-3zm0 5v2h1.5v-2z" />
    </Icon>
  );
}

WithdrawIcon.displayName = 'WithdrawIcon';
